var _style, _g, _path, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "130px",
    height: "130px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.Drop_x0020_Shadow{fill:none;}\n\t.Round_x0020_Corners_x0020_2_x0020_pt{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.Live_x0020_Reflect_x0020_X{fill:none;}\n\t.Bevel_x0020_Soft{fill:url(#SVGID_1_);}\n\t.Dusk{fill:#FFFFFF;}\n\t.Foliage_GS{fill:#FFDD00;}\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#44ADE2;}\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15,
    y1: 15,
    x2: 15.7071047,
    y2: 15.7071095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEDFE3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738151,
    style: {
      stopColor: "#D8D9DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352005,
    style: {
      stopColor: "#C9CACD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322592,
    style: {
      stopColor: "#B4B5B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7138845,
    style: {
      stopColor: "#989A9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8949245,
    style: {
      stopColor: "#797C7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#656B6C"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.6399994,62.8482513v33.2600021c0,2.5299988-0.3700027,4.9599991-1.0699997,7.2599945H10.4300003 c-0.7000008-2.2999954-1.0700006-4.7299957-1.0700006-7.2599945V62.8482513H120.6399994z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.6399994,50.458252v12.3899994H9.3599997V33.8882523 c0-13.8800011,11.250001-25.1300011,25.1399994-25.1300011h45.1699982l0.0699997,0.0700006 c-0.3899994,2.0900002-0.5899963,4.25-0.5899963,6.4499998c0,19.5699997,15.8600006,35.4399986,35.4399948,35.4399986 c1.9900055,0,3.9300003-0.1599998,5.8300018-0.4799995h0.0100021L120.6399994,50.458252z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7399979,8.8282518l40.6800003,41.4099998c-1.9000015,0.3199997-3.8399963,0.4799995-5.8300018,0.4799995 c-19.5799942,0-35.4399948-15.8699989-35.4399948-35.4399986C79.1500015,13.0782518,79.3499985,10.918252,79.7399979,8.8282518z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4300003,103.368248h109.1399994C116.4599991,113.7182541,106.8600006,121.2482529,95.5,121.2482529h-61 C23.1399994,121.2482529,13.54,113.7182541,10.4300003,103.368248z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.4199982,50.2382507L79.7399979,8.8282518l-0.0699997-0.0700006H34.5 c-13.8899994,0-25.1399994,11.25-25.1399994,25.1300011v28.9599991v33.2600021 c0,2.5299988,0.3699999,4.9599991,1.0700006,7.2599945C13.54,113.7182541,23.1399994,121.2482529,34.5,121.2482529h61 c11.3600006,0,20.9599991-7.5299988,24.0699997-17.8800049c0.6999969-2.2999954,1.0699997-4.7299957,1.0699997-7.2599945 V62.8482513V50.458252l-0.2099991-0.2200012"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 9.3599997,
    y1: 62.8482513,
    x2: 120.6399994,
    y2: 62.8482513
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 10.4300003,
    y1: 103.368248,
    x2: 119.5699997,
    y2: 103.368248
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.4300003,50.2382507h-0.0100021c-1.9000015,0.3199997-3.8399963,0.4799995-5.8300018,0.4799995 c-19.5799942,0-35.4399948-15.8699989-35.4399948-35.4399986c0-2.1999998,0.1999969-4.3599997,0.5899963-6.4499998 c0-0.0200005,0.0100021-0.04,0.0100021-0.0600004"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.7461548,8.7683048"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.2211914,70.5322266h8.9575195c6.0092773,0,9.0322266,2.7988281,9.0322266,7.875 c0,5.3369141-3.3964844,8.1367188-8.7333984,8.1367188h-4.6655273v9.5917969h-4.5908203V70.5322266z M38.6191406,83.1103516 c3.4711914,0,4.7773438-1.4560547,4.7773438-4.4414062c0-3.359375-1.3061523-4.5908203-4.7026367-4.5908203h-3.8818359v9.0322266 H38.6191406z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.3945312,70.5322266h5.1508789l10.637207,18.0644531h0.1113281V70.5322266h4.0683594v25.6035156h-4.5537109 L57.574707,76.8398438h-0.1118164v19.2958984h-4.0683594V70.5322266z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.9941406,83.8564453v-0.7841797c0-9.7412109,5.8964844-12.9501953,12.5400391-12.9501953 c3.2851562,0,5.5244141,0.7089844,7.0166016,1.4921875v3.6582031c-1.5302734-0.671875-3.5078125-1.4189453-6.9042969-1.4189453 c-6.0087891,0-7.8007812,4.03125-7.8007812,8.8457031v1.1572266c0,5.2998047,1.3808594,9.0693359,7.390625,9.0693359 c1.4921875,0,2.9853516-0.2607422,3.9189453-0.5595703v-5.8222656h-4.7402344v-3.4335938h9.21875v11.8681641 c-1.9414062,0.7841797-4.9267578,1.5673828-8.3603516,1.5673828 C83.7714844,96.5458984,78.9941406,92.8515625,78.9941406,83.8564453z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.822bc59e33c682c555e3cf1d41636f02.svg";
export { ForwardRef as ReactComponent };